import React from 'react'
import dmo from '../images/clients/dmo.png';
import kikstart from '../images/clients/logo kikstart1.png';
import abs from '../images/clients/ABS_LOGO_final.png';
import '../index.css'

function SliderList() {
  return (
    <ul
      className="absolute h-full w-[200%] flex items-center justify-between"
      style={{
        animation: 'slide-left-to-right 25s linear infinite', 
        whiteSpace: 'nowrap', 
      }}
    >
     
      <li
        style={{
          marginRight: '50px',
          flexShrink: 0,
          display: 'inline-block', 
        }}
      >
        <img
          src={dmo}
          //  className='w-56 h-44'
          alt=""
          style={{
            objectFit: 'contain',
            maxWidth: '80%',
            maxHeight: '80%',
          }}
        />
      </li>
      <li
        style={{
          marginRight: '50px',
          flexShrink: 0,
          display: 'inline-block',
        }}
      >
        <img
          src={kikstart}
          //  className='w-56 h-44'
          alt=""
          style={{
            objectFit: 'contain',
            maxWidth: '80%',
            maxHeight: '80%',
          }}
        />
      </li>

      <li
        style={{
          marginRight: '50px',
          flexShrink: 0,
          display: 'inline-block',
        }}
      >
        <img
          src={abs}
          //  className='w-56 h-44'
          alt=""
          style={{
            objectFit: 'contain',
            maxWidth: '25%',
            maxHeight: '25%',
          }}
        />
      </li>
      <li
        style={{
          marginRight: '50px',
          flexShrink: 0,
          display: 'inline-block', 
        }}
      >
        <img
          src={dmo}
          //  className='w-56 h-44'
          alt=""
          style={{
            objectFit: 'contain',
            maxWidth: '80%',
            maxHeight: '80%',
          }}
        />
      </li>
      <li
        style={{
          marginRight: '50px',
          flexShrink: 0,
          display: 'inline-block',
        }}
      >
        <img
          src={kikstart}
          //  className='w-56 h-44'
          alt=""
          style={{
            objectFit: 'contain',
            maxWidth: '80%',
            maxHeight: '80%',
          }}
        />
      </li>

      <li
        style={{
          marginRight: '50px',
          flexShrink: 0,
          display: 'inline-block',
        }}
      >
        <img
          src={abs}
          //  className='w-56 h-44'
          alt=""
          style={{
            objectFit: 'contain',
            maxWidth: '25%',
            maxHeight: '25%',
          }}
        />
      </li>
      
    </ul>
  );
}

export default SliderList;